import { render } from "./CustomerCreate.vue?vue&type=template&id=773749b4&scoped=true&ts=true"
import script from "./CustomerCreate.vue?vue&type=script&lang=ts"
export * from "./CustomerCreate.vue?vue&type=script&lang=ts"

import "./CustomerCreate.vue?vue&type=style&index=0&id=773749b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-773749b4"]])

export default __exports__